/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {Runner, RunnerFromJSON, RunnerToJSON,} from './Runner';

/**
 *
 * @export
 * @interface RunnerApiResult
 */
export interface RunnerApiResult {
    /**
     *
     * @type {boolean}
     * @memberof RunnerApiResult
     */
    success?: boolean;
    /**
     *
     * @type {Runner}
     * @memberof RunnerApiResult
     */
    content?: Runner;
    /**
     *
     * @type {string}
     * @memberof RunnerApiResult
     */
    message?: string | null;
}

export function RunnerApiResultFromJSON(json: any): RunnerApiResult {
    return RunnerApiResultFromJSONTyped(json, false);
}

export function RunnerApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunnerApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : RunnerFromJSON(json['content']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function RunnerApiResultToJSON(value?: RunnerApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': RunnerToJSON(value.content),
        'message': value.message,
    };
}

